/**
 * Layouts contributed by this product.
 *
 * The server-management surfaces live behind sign-in and reuse the auth
 * layer's <Shell>. Registering them here is what let every page drop its own
 * <AuthGuard> and <AppLayout> wrapper — the shell owns both now.
 */
import { DashboardLayoutRoute } from './DashboardLayoutRoute';
import type { LayoutEntry } from './layouts';
import { PLATFORM_MODULES } from './config/platform-modules';

/*
 * Every signed-in product surface. Derived from the module catalog for the same
 * reason the nav is: a module page that is missing from this list still renders,
 * but without the shell around it — no sidebar, no header — which looks like a
 * broken page rather than a missing line of config.
 */
const AREAS = [
  // Neither is a module bloomneo offers: /customers is who the modules belong
  // to, and /account is one customer's view of their own record. Both are
  // signed-in surfaces and need the shell, so both are named by hand.
  'customers',
  'account',
  ...PLATFORM_MODULES.map((m) => m.key),
];

export const entries: LayoutEntry[] = AREAS.map((area, i) => ({
  match: (p) => p === `/${area}` || p.startsWith(`/${area}/`),
  Layout: DashboardLayoutRoute,
  order: 150 + i,
}));
